// import burger from "./parts/burger";
// import herosSlider from "./parts/hero-slider";
// import swiper from "./parts/swiper";
// import contactModal from "./parts/form-modal";
import btnmodals from "./parts/modal";
// import cursor from "./parts/cursor";
import animations from "./parts/gsap";
// import btn from "./parts/btn";

document.addEventListener("DOMContentLoaded", () => {
	// burger();
	btnmodals();
	// herosSlider();
	// contactModal();
	// cursor();
	// animations();
	// btn();	
});


